import { render, staticRenderFns } from "./newsSearch.vue?vue&type=template&id=5ba2c4ea"
import script from "./newsSearch.vue?vue&type=script&lang=js"
export * from "./newsSearch.vue?vue&type=script&lang=js"
import style0 from "./newsSearch.vue?vue&type=style&index=0&id=5ba2c4ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports